'use strict';

var Component_v1alpha1_schema = require('../schema/kinds/Component.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const componentEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(Component_v1alpha1_schema.default);

exports.componentEntityV1alpha1Validator = componentEntityV1alpha1Validator;
//# sourceMappingURL=ComponentEntityV1alpha1.cjs.js.map
